export default {
  SEARCH_YOUR_BANK: 'Cerca la tua banca',
  VAT: 'IVA',
  TYPE_YOUR_BANK_NAME_TO_FIND: 'Digita il nome della tua banca per trovarla',
  LOADING_INSTITUTIONS: 'Ricerca banche in corso…',
  NO_MATCHING_BANK: 'Nessuna banca corrispondente',
  CONFIRM: 'Conferma',
  PHONE_NUMBER: 'Cellulare',
  SIGNUP: 'Registrati',
  TRANSACTIONS: 'Storico Transazioni',
  ACCOUNT: 'Conto',
  ADD_COMPANY: 'Aggiungi azienda',
  NAME: 'Nome',
  CODE: 'Codice',
  TAX_NUMBER: 'Codice fiscale',
  VAT_NUMBER: 'Partita IVA',
  WEB: 'Sito web',
  REQUIRED: ' è obbligatorio',
  BALANCE: 'Saldo',
  FROM: 'Da',
  NOTHING_FOUND: 'Nessun risultato',
  NO_AVAILABLE_OPTIONS: 'Nessun elemento',
  CLEAR_ALL_FILTERS: 'Rimuovi tutti i filtri',
  CLEAR_FILTERS: 'Rimuovi filtri',
  DATE: 'Data',
  AMOUNT: 'Importo',
  CATEGORY: 'Categoria',
  CURRENCY: 'Valuta',
  COMPANY: 'azienda',
  BANK_NOT_LISTED: 'Crea un conto manuale',
  CURRENCY_IS_REQUIRED: 'La valuta è richiesta',
  INVALID_TAX_NUMBER_LENGTH_11: 'Codice fiscale non valido. Deve avere 11 caratteri',
  INVALID_TAX_NUMBER_LENGTH_16: 'Codice fiscale non valido. Deve avere 16 carattteri',
  INVALID_VAT_NUMBER_LENGTH_11: 'Partita IVA invalida. Deve avere 11 caratteri',
  NAME_REQUIRED: 'Il nome è richiesto',
  INVALID_PHONE_NUMBER: 'Numero non valido',
  JOIN_COMPANY_ERROR_MESSAGE: "C'è stato un errore durante la creazione della richiesta",
  JOIN_COMPANY_ALREADY_EXISTS_ERROR_MESSAGE: "L'azienda è gia presente tra quelle disponibili",
  ADD_COMPANY_ERROR_MESSAGE: "C'è stato un errore durate la creazione dell'azienda",
  SUBMIT: 'Conferma',
  CANCEL: 'Annulla',
  HELLO: 'Ciao',
  INVOICE_ADDED: 'Fattura creata',
  INVOICE_CREATION_ERROR: 'Errore durante la creazione della fattura',
  DOCUMENT: 'Documento',
  INVOICE_UPDATED: 'Fattura aggiornata',
  INVOICE_UPDATE_ERROR: "Errore durante l'aggiornamento della fattura",
  INVOICE: 'Fattura',
  BILLS: 'Corrispettivi',
  BILL: 'Corrispettivo',
  RECEIPT: 'Ricevuta',
  OTHER: 'Altro',
  COUNTERPART_ISSUED: 'Cliente',
  COUNTERPART_RECEIVED: 'Fornitore',
  DESCRIPTION: 'Descrizione',
  DOCUMENT_DATE: 'Data documento',
  FLOW_NUMBER: 'Numero documento',
  INCLUDING_VAT: 'Importo IVA inclusa',
  VAT_PERCENTAGE: 'IVA %',
  DOCUMENT_TYPE: 'Tipo Documento',
  CREATE_FLOWS: 'Crea scadenze',
  PAYMENTS: 'Pagamenti',
  FLOW_NAME: 'Nome flusso',
  DUE_DATE: 'Scadenza',
  ORIGINAL_DUE_DATE: 'Data di pagamento originale',
  PAYMENT_DATE: 'Scadenza',
  PAYMENT_STATUS: 'Stato',
  PAYMENT_METHOD: 'Modalità di pagamento',
  INVOICE_PAYMENT_ACCOUNT: 'Conto in fattura',
  PAYMENT_ACCOUNT: 'Conto di pagamento',
  NOTES: 'Note',
  SEARCH: 'Ricerca',
  COUNTERPART_REQUIRED_ISSUED: 'Cliente richiesto',
  COUNTERPART_REQUIRED_RECEIVED: 'Fornitore richiesto',
  DOCUMENT_DATE_REQUIRED: 'Data documento richiesto',
  FLOW_NUMBER_REQUIRED: 'Numero fattura richiesto',
  FLOW_NAME_REQUIRED: 'Descrizione pagamento richiesto',
  PAYMENT_DATE_REQUIRED: 'Data di pagamento richiesta',
  PAYMENT_STATUS_REQUIRED: 'Stato pagamento richiesto',
  SAVE: 'Salva',
  WEEK: 'Settimana',
  MONTH: 'Mese',
  ON: 'Il',
  PAID_OUTFLOW: 'Pagato',
  TO_PAY_OUTFLOW: 'Da pagare',
  PAID_INFLOW: 'Incassato',
  TO_PAY_INFLOW: 'Da incassare',
  PAID_COMBINED: 'Pagato/Incassato',
  TO_PAY_COMBINED: 'Da pagare/incassare',
  PARTIALLY_PAID_INFLOW: 'Parzialmente incassato',
  PARTIALLY_PAID_OUTFLOW: 'Parzialmente pagato',
  TYPE: 'Tipo',
  TO: 'A',
  FILTERS: 'Filtri',
  FILTER: 'Filtro',
  CLEAR: 'Reimposta',
  CONTAINS: 'Contiene',
  RECOVER_ENTRATEL_CREDENTIALS: 'Recupera credenziali',
  EDIT: 'Modifica',
  FLOWS: 'Scadenze',
  INFLOWS: 'Entrate',
  OUTFLOWS: 'Uscite',
  CREDIT_NOTE: 'Nota di credito',
  DEBIT_NOTE: 'Nota di debito',
  SELF_INVOICE: 'Autofattura',
  PARCEL: 'Parcella',
  DELETE_FLOW: 'Elimina scadenza',
  THIS_ACTION_CANNOT_BE_UNDONE: 'Vuoi confermare? Questa azione è irreversibile.',
  ERROR_SUBMITTING_FLOW: 'C’è stato un errore',
  TOTAL_VAT_REQUIRED: 'Importo IVA inclusa richiesto',
  NONE: 'Nessuno',
  TRANSFER: 'Bonifico',
  CASH: 'Contanti',
  CARD: 'Carta',
  CHECK: 'Assegno',
  POSTAL: 'Bollettino',
  RIBA: 'RIBA',
  SDD: 'SDD',
  TAX_FORM: 'F24',
  FISCAL_CREDIT: 'Credito Fiscale',
  DEFERRED: 'Senza Incasso',
  AUTHORIZED: 'Autorizzato',
  TOTAL: 'Totale',
  TOTAL_AMOUNT: 'Importo',
  INVOICES_AND_CREDIT_NOTES: 'Fatture',
  ACTIVE: 'Attivo',
  SELECT_INSTITUTION: 'Seleziona istituto',
  ACCOUNT_NAME: 'Nome conto',
  CLOSE: 'Chiudi',
  OPEN: 'Apri',
  ENTREPRENEUR: 'Imprenditore',
  EMPLOYEE: 'Dipendente',
  ADVISOR: 'Consulente',
  PASSWORD: 'Password',
  ERROR: 'Errore',
  BANKS: 'Banks',
  TOO_MANY_FLOWS_TO_EXPORT: 'Troppi flussi da esportare',
  GO_TO_ACCOUNTS: 'Gestisci conti',
  OOPS: 'Ops!',
  ENCOUNTERED_ERROR: 'Spiacenti, si è verificato un errore',
  VERIFIED: 'Verificato',
  TO_VERIFY: 'Da verificare',
  VERIFICATION_STATUS: 'Status',
  GETTING_STARTED: 'Primi passi',
  FEW_TIPS_TO_GET_BEST: 'Per avere tutto sotto controllo, inizia collegando i tuoi strumenti a Sibill.',
  CONNECT_YOUR_BANK_ACCOUNT_TITLE: 'Banche in tempo reale',
  CONNECT_YOUR_BANK_ACCOUNT_DESCRIPTION: 'Abilita il multi-banking in tempo reale, per te e il tuo team.',
  CONNECT_YOUR_INVOICING_SYSTEM_TITLE: 'Riconciliazioni e previsioni automatiche',
  CONNECT_YOUR_INVOICING_SYSTEM_DESCRIPTION:
    'Abilita previsioni del flusso di cassa, riconciliazione e pagamenti facili.',
  START_HERE: 'Inizia qui',
  ALMOST_THERE: 'Ci sei quasi!',
  REJECTED: 'Respinto',
  IGNORE: 'Ignora',
  TOTAL_ACCOUNTS: 'Totale conti',
  TOTAL_AVAILABLE_BALANCE_IN_EUR: 'Totale saldo disponibile in <greenBold>EUR</greenBold>',
  REMOVE: 'Rimuovi',
  DEFAULT: 'Predefinito',
  RECONNECT: 'Riconnetti',
  PLAN: 'Piano',
  JOIN_COMPANY_ALREADY_PRESENT_MESSAGE:
    'Abbiamo inoltrato una richiesta d’accesso all’amministratore dell’attività. Ti invieremo una mail di conferma quando riceverai l’accesso al team.',
  COMPANY_AUTHENTICATION_FAILED: 'Impossibile cambiare azienda',
  ADVISOR_TEXT_1:
    'Se sei incaricato dello studio commercialista delegato, inserisci il codice che normalmente selezioni in “Fatture e corrispettivi” alla sezione “2. Scegli per chi operare”. Di solito inizia con il codice fiscale dello studio commercialista',
  ADVISOR_TEXT_2: 'Se sei un commercialista con delega diretta, questo campo va lasciato vuoto',
  TABLE_METADATA_RESULTS: '{{total}} risultati',
  ACCOUNTING: 'Fatturazione',
  CONNECT: 'Collegare',
  RESTORE: 'Ristabilire',
  REFRESH: 'Ricarica',
  ID: 'Codice utente',
  CONTINUE: 'Continua',
  ADD: 'Aggiungi',
  DUE_ON: 'Dovuta il {{date}}',
  UPLOAD: 'Carica',
  DEADLINES: 'Scadenze',
  ADD_DEADLINE: 'Aggiungi scadenza',
  RENAME: 'Rinomina',
  CATEGORY_COLOR_PALETTE_LABEL: 'Colore della categoria',
  RENAME_CATEGORY_HELP_TEXT: 'Premi invio per confermare',
  UNCATEGORISED: 'Non categorizzata',
  TRANSACTIONS_WELCOME_TITLE: 'Benvenuto nella sezione storico movimenti!',
  TRANSACTIONS_WELCOME_BODY:
    'In questa sezione puoi monitorare i tuoi incassi e pagamenti.\n\nInizia collegando un conto.',
  LAST_TWELVE_MONTHS_SHORT: 'Ultimi 12 mesi',
  REMOVE_CATEGORY: 'Rimuovi categoria',
  MISSING_DOCUMENT: 'Non è stato possibile caricare il documento',
  EXPIRED_DOCUMENT: 'Il link al documento è scaduto. Ricaricare la pagina',
  FLOWS_TO_PAY_ON_INFLOW: 'Da incassare il',
  FLOWS_TO_PAY_ON_OUTFLOW: 'Da pagare il',
  ERROR_EXPORTING: "Si è verificato un'errore durante l'esportazione",
  FLOW_UPDATED: 'Scadenza aggiornata',
  WAITING_FOR_APPROVAL: 'In attesa di approvazione',
  REMOVED_COMPANY_PAGE_TITLE: 'Benvenuto',
  REMOVED_COMPANY_PAGE_ADVERTISE_BOX_TITLE: 'Azienda non disponibile',
  REMOVED_COMPANY_PAGE_ADVERTISE_BOX_DESCRIPTION:
    "Siamo spiacenti, l'azienda a cui stai cercando di accedere non è più disponibile.",
  UNAUTHORISED_COMPANY_PAGE_TITLE: 'Benvenuto',
  UNAUTHORISED_COMPANY_PAGE_ADVERTISE_BOX_TITLE: 'Sei in attesa dell’autorizzazione',
  UNAUTHORISED_COMPANY_PAGE_ADVERTISE_BOX_DESCRIPTION:
    "Inoltreremo una richiesta d'accesso all'amministratore dell’azienda. Ti invieremo una mail di conferma quando riceverai l'accesso al team.",
  LOADING: 'In caricamento…',
  INVOICES_STATUS_ON_IMPORT_MESSAGE:
    'Le fatture con data di pagamento nel passato verranno importate come pagate. Terminata l’importazione potrai cambiare gli stati di pagamento.',
  TAB_BANKS_TRANSACTIONS: 'Movimenti',
  CASHBOOK: 'Prima nota',
  FILTER_CATEGORIES_SELECTED: '{{count}} categorie',
  FILTER_SUBCATEGORIES_SELECTED: '{{count}} sottocategorie',
  FILTER_PAYMENT_METHOD_LABEL: 'Pagamento',
  FILTER_PAYMENT_METHODS_SELECTED: '{{count}} metodi',
  CUSTOM: 'Personalizza',
  BACK_TO_TOP: 'Torna in cima',
  BILLS_FLOWS_TAB_LABEL: 'Incassi',
  ALREADY_REMINDER: 'Hai inviato un promemoria il ',
  RECURRENCE: 'Ricorrenza',
  BACK: 'Indietro',
  DELIVERY_NOTE: 'Documento di trasporto',
  QUOTE: 'Preventivo',
  NEW: 'Novità',
} as const;
